module.exports = "/_next/static/images/case3-cover-e3887964d187ea5552957635f5d2cdc7.jpg";